import index from '../objects/collection/index';

index();
